const e = [
  "1.2rem",
  "1.4rem",
  "1.6rem",
  "1.8rem",
  "2.1rem",
  "2.4rem",
  "3.2rem",
  "4.8rem",
  "7.2rem",
  "10.8rem"
];
e.headingHugeDesktop = e[9];
e.headingLargeDesktop = e[8];
e.headingMediumDesktop = e[7];
e.headingSmallDesktop = e[6];
e.headingXsmallDesktop = e[5];
e.textLargeDesktop = e[5];
e.textMediumDesktop = e[3];
e.textSmallDesktop = e[2];
e.textXsmallDesktop = e[1];
e.headingHugeMobile = e[7];
e.headingLargeMobile = e[6];
e.headingMediumMobile = e[5];
e.headingSmallMobile = e[4];
e.headingXsmallMobile = e[3];
e.textLargeMobile = e[3];
e.textMediumMobile = e[2];
e.textSmallMobile = e[1];
e.textXsmallMobile = e[0];
export {
  e as default
};
